import { render, staticRenderFns } from "./LabelPickerAdvancedDocumentLabels.vue?vue&type=template&id=0fcff883"
import script from "./LabelPickerAdvancedDocumentLabels.vue?vue&type=script&lang=ts"
export * from "./LabelPickerAdvancedDocumentLabels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports